import l10n from "../lib/l10n";

export const useUser = () => {
  const user = l10n.__getvar('u_');
  return ({
    user,
    getRole: role => user?.role && user.role.indexOf(role) >= 0,
  });
};